<div class="container p-4">
  <div class="row">
    <h2 class="head">Filter Webinars</h2>
  </div>
  <form [formGroup]="webinarFilterForm">
    <div class="filter-row">
      <div class="filter-column">
        <div class="col-lg-4">
          <p class="label">Added On</p>
          <mat-form-field class="filter-input" appearance="outline">
            <mat-date-range-input [rangePicker]="picker">
              <input
                matStartDate
                placeholder="Start"
                formControlName="startDate"
              />
              <input matEndDate placeholder="End" formControlName="endDate" />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <p class="label">Status</p>
          <mat-form-field appearance="outline" class="filter-input">
            <mat-select formControlName="status" placeholder="Select Status">
              <mat-option
                *ngFor="let status of webinarStatus"
                [value]="status.label"
              >
                {{ status.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-4">
          <mat-label class="label">Speaker</mat-label>
          <mat-form-field appearance="outline" class="fields input-font w-100">
            <input
              type="text"
              placeholder="Search Speaker"
              matInput
              [formControl]="speakerControl"
              [matAutocomplete]="autoSpeaker"
            />
            <mat-autocomplete #autoSpeaker="matAutocomplete" (optionSelected)="onSpeakerSelected($event)">
              <mat-option *ngFor="let speaker of filteredSpeakers" [value]="speaker">
                {{ speaker }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="filter-row">
      <div class="filter-column">   
        <div class="col-lg-4">
          <mat-label class="label">Organization</mat-label>
          <mat-form-field appearance="outline" class="fields input-font w-100 mt-1">
            <input
              type="text"
              placeholder="Search Organization"
              matInput
              [formControl]="orgControl"
              [matAutocomplete]="autoOrg"
            />
            <mat-autocomplete #autoOrg="matAutocomplete" (optionSelected)="onOrganizationSelected($event)">
              <mat-option *ngFor="let organization of filteredOrganizations" [value]="organization">
                {{ organization }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>       
        <div class="col-lg-4">
          <mat-label class="label">Company Name</mat-label>
          <mat-form-field appearance="outline" class="fields input-font w-100 mt-1">
            <input
              type="text"
              placeholder="Search Company Name"
              matInput
              [formControl]="companyControl"
              [matAutocomplete]="autoCompanyName"
            />
            <mat-autocomplete #autoCompanyName="matAutocomplete" (optionSelected)="onCompanyNameSelected($event)">
              <mat-option *ngFor="let companyNames of filteredCompanies" [value]="companyNames">
                {{ companyNames }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>        
        <div class="col-lg-4">
          <mat-label class="label">Created By</mat-label>
          <mat-form-field appearance="outline" class="fields input-font w-100 mt-1">
            <input
              type="text"
              placeholder="Search Created By"
              matInput
              [formControl]="createdByControl"
              [matAutocomplete]="autoCreatedBy"
            />
            <mat-autocomplete #autoCreatedBy="matAutocomplete" (optionSelected)="onCreatedBySelected($event)">
              <mat-option *ngFor="let createdBy of filteredCreators" [value]="createdBy">
                {{ createdBy }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="filter-row">
      <div class="filter-column">  <div class="col-log-4">
          <mat-label class="label">Event Type</mat-label>
          <mat-form-field appearance="outline" class="filter-input">
            <mat-select formControlName="type" placeholder="Select Type">
              <mat-option
                *ngFor="let type of webinarType"
                [value]="type.label"
              >
                {{ type.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row mt-3" *ngIf="hasActiveFilters()">
      <div class="col-12 applied-filters">
        <p class="mt-1">Filters applied:</p>
        <div class="chip-container">
          <mat-chip-list>
            <mat-chip
              *ngIf="webinarFilterForm.value.startDate"
              color="primary"
              selected
              removable
              class="webinar-chip-item"
              (removed)="removeChip({ name: webinarFilterForm.value.startDate, type: GeographicalType.DATE })"
            >
              Date Range: {{ webinarFilterForm.value.startDate | date:'MM/dd/yyyy' }} - {{ webinarFilterForm.value.endDate | date:'MM/dd/yyyy' }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <mat-chip
              *ngIf="webinarFilterForm.value.status"
              color="primary"
              selected
              removable
              class="webinar-chip-item"
              (removed)="removeChip({ name: webinarFilterForm.value.status, type: GeographicalType.STATUS })"
            >
              {{ webinarFilterForm.value.status }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip
              *ngFor="let speaker of selectedSpeakers"
              color="primary"
              selected
              removable
              class="webinar-chip-item"
              (removed)="removeChip({ name: speaker, type: GeographicalType.SPEAKER })"
            >
              {{ speaker }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip
              *ngFor="let organization of selectedOrganizations"
              color="primary"
              selected
              removable
              class="webinar-chip-item"
              (removed)="removeChip({ name: organization, type: GeographicalType.ORGANIZATION })"
            >
              {{ organization }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip
              *ngFor="let company of selectedCompanies"
              color="primary"
              selected
              removable
              class="webinar-chip-item"
              (removed)="removeChip({ name: company, type: GeographicalType.COMPANY_NAME })"
            >
              {{ company }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <mat-chip
            *ngFor="let creator of selectedCreators"
            color="primary"
            selected
            removable
            class="webinar-chip-item"
            (removed)="removeChip({ name: creator.name, type: GeographicalType.CREATED_BY })"
          >
            {{ creator.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
              <mat-chip
              *ngIf="webinarFilterForm.value.type"
              color="primary"
              selected
              removable
              class="webinar-chip-item"
              (removed)="removeChip({ name: webinarFilterForm.value.type, type: GeographicalType.TYPE })"
            >
              {{ webinarFilterForm.value.type }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
    </div>

    <div class="popup-action mt-4">
      <button
        class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3"
        (click)="applyFilter()"
      >
        Filter
      </button>
      <button
        class="mwe-button mwe-button--secondary ps-3 pe-3"
        (click)="clearFilter()"
      >
        Clear
      </button>
      <button
        class="mwe-button mwe-button--secondary ps-3 pe-3"
        (click)="closeDialog()"
      >
        Clear & Cancel
      </button>
    </div>
  </form>
</div>

